/* image rollover */

export function rollOverInit() {
    if ($('.with-rollover').length) {
        console.log("rollOverInit");
$( ".with-rollover" ).hover(
    function() {
        $(this).addClass('rolled-over');
        //blazyInit();
    }, function() {
        $(this).removeClass('rolled-over');
        blazyInit();
    }
);
    }
}

/* image rollover */

export function contactGoogleMapInit() {
    // When the window has finished loading create our google map below
    google.maps.event.addDomListener(window, 'load', initContactGoogleMap);
        
    function initContactGoogleMap() {
        // Basic options for a simple Google Map
        // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
        var mapOptions = {
            // How zoomed in you want the map to start at (always required)
            zoom: 16,

            // The latitude and longitude to center the map (always required)
            center: new google.maps.LatLng(51.901042900474145, -2.0787249519361226),

            // How you would like to style the map. 
            // This is where you would paste any style found on Snazzy Maps.
            styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
        };

        // Get the HTML DOM element that will contain your map 
        // We are using a div with id="map" seen below in the <body>
        var mapElement = document.getElementById('map');

        // Create the Google Map using our element and options defined above
        var map = new google.maps.Map(mapElement, mapOptions);

        // Let's also add a marker while we're at it
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(51.901042900474145, -2.0787249519361226),
            map: map,
            title: 'ASHA & Co.'
        });
    }
}

/* work headers */

export function mobHeaderInit(element) {
    var windowWidth = window.innerWidth;
    console.log('windowWidth = ' + windowWidth);
    if (windowWidth < 768) {
        if(window.innerHeight > window.innerWidth){
            //portrait
            var windowHeight = window.innerHeight - 56;
        console.log('windowHeight = ' + windowHeight);
        $(element).css('height', windowHeight + 'px');
        } else {
            $(element).css('height', '');
        }
        
    } else {
        $(element).css('height', '');
    }
    
}

/* lazy loading */

export function blazyInit() {
    console.log("Blazy init");
    var bLazy = new Blazy({
        breakpoints: [{
        width: 420 // Max-width
          , src: 'data-src-small'
    }], 
    success: function(element){
        setTimeout(function(){
        // We want to remove the loader gif now.
        // First we find the parent container
        // then we remove the "loading" class which holds the loader image
        var parent = element.parentNode;
        parent.className = parent.className.replace(/\bloading\b/,'');
        }, 200);
    },
    error: function(element,msg){
        console.log("blazy error: " + msg);
    },
    });

    /*$(window).bind('load', function () {
    var pause = 1000;
        $( '.work-modular-content video.b-lazy:not(".b-loaded")' ).each(function( index ) {
            var whichVideoID = $(this).attr('id');
            setTimeout(function(){
                console.log('whichVideoID = ' + whichVideoID);
                bLazy.load($('#' + whichVideoID), true);
        }, pause);
        pause += 1000;
        });
    });*/
}

/*export function blazyScrollInit() {
    if ($('.scroll-items').length) {
    console.log("Blazy scroll init");
    var bLazyScroll = new Blazy({
        breakpoints: [{
        width: 420 // Max-width
          , src: 'data-src-small'
    }],
    container: '.scroll-items'
    });
}
}*/

export function focusInput(id) {
    console.log('search open');
    $(id).focus();
};

/* close modals on page load */

export function closeModals() {
    console.log('backdrop check');
    if ($('.modal-backdrop.show').length) {
        console.log('backdrop open');
    $("body").removeClass('modal-open');
    $('.modal-backdrop').removeClass('show');
    }
}

/* scrollbar */

export function scrollbarInit(id) {
    if ($('.text-scroll-black').length) {
        console.log("Scrollbar init");
        $(".text-scroll-black").mCustomScrollbar({
            axis:"y",
            theme:"dark-thin",
            autoHideScrollbar:false,
            scrollbarPosition: "inside",
            mouseWheel:{ enable: true },
            contentTouchScroll: false
        });
    }

    if ($('.text-scroll-black-with-images').length) {
        console.log("Scrollbar init");
        $(".text-scroll-black-with-images").mCustomScrollbar({
            axis:"y",
            theme:"dark-thin",
            autoHideScrollbar:false,
            scrollbarPosition: "inside",
            mouseWheel:{ enable: true },
            scrollButtons:{ enable: false },
            contentTouchScroll: false,
            callbacks:{
                onScroll:function(){
                  console.log("Content scrolled...");
                  blazyInit();
                }
            }
        });
    }
} 

/* scrollbooster */

import ScrollBooster from 'scrollbooster';

export function ScrollBoosterInit() {

    if ($('.hscroll1').length) {

        const viewport = document.querySelector(".hscroll1 .viewport");
    
        console.log("Scrollbooster init");

        const sb1 = new ScrollBooster({
            viewport: document.querySelector(".hscroll1 .viewport"),
	direction: "horizontal",
	scrollMode: 'native',
    bounce: false,
    onUpdate: (isDragging) => {
        // state contains useful metrics: position, dragOffset, dragAngle, isDragging, isMoving, borderCollision
        // you can control scroll rendering manually without 'scrollMethod' option:
        blazyInit();
      },
          });

          sb1.updateMetrics(); // updates on resize


     } 
     
     if ($('.hscroll2').length) {

        const viewport = document.querySelector(".hscroll2 .viewport");
    
        console.log("Scrollbooster init");

        const sb2 = new ScrollBooster({
            viewport: document.querySelector(".hscroll2 .viewport"),
	direction: "horizontal",
	scrollMode: 'native',
    bounce: false,
    onUpdate: (isDragging) => {
        // state contains useful metrics: position, dragOffset, dragAngle, isDragging, isMoving, borderCollision
        // you can control scroll rendering manually without 'scrollMethod' option:
        blazyInit();
      },
          });

          sb2.updateMetrics(); // updates on resize

     }

     if ($('.hscroll3').length) {

        const viewport = document.querySelector(".hscroll3 .viewport");
    
        console.log("Scrollbooster init");

        const sb3 = new ScrollBooster({
            viewport: document.querySelector(".hscroll3 .viewport"),
	direction: "horizontal",
	scrollMode: 'native',
    bounce: false,
    onUpdate: (isDragging) => {
        // state contains useful metrics: position, dragOffset, dragAngle, isDragging, isMoving, borderCollision
        // you can control scroll rendering manually without 'scrollMethod' option:
        blazyInit();
      },
          });

          sb3.updateMetrics(); // updates on resize

     }

     if ($('.hscroll4').length) {

        const viewport = document.querySelector(".hscroll4 .viewport");
    
        console.log("Scrollbooster init");

        const sb4 = new ScrollBooster({
            viewport: document.querySelector(".hscroll4 .viewport"),
	direction: "horizontal",
	scrollMode: 'native',
    bounce: false,
    onUpdate: (isDragging) => {
        // state contains useful metrics: position, dragOffset, dragAngle, isDragging, isMoving, borderCollision
        // you can control scroll rendering manually without 'scrollMethod' option:
        blazyInit();
      },
          });

          sb4.updateMetrics(); // updates on resize

     }
}


/* parallax */

/*if ($('.parallax-window').length) {
    $('.parallax-window').parallax({
        naturalWidth: 600,
        naturalHeight: 400
      });
}*/

/* slick slider */

/* product gallery thumbnails */

export function slickInit() {

    console.log("Slider init");

    if ($('.content-slider').length) {

        if ($('.content-slider.slick-initialized').length) {

            console.log("Content slider exists");

            $('.content-slider').slick('refresh');

        } else {

            console.log("Content slider created");        

$(".content-slider").slick({
    // normal options...
    infinite: true,
    lazyLoad: 'progressive',
  slidesToShow: 1,
  slidesToScroll: 1
  });

  $(document).on("afterChange", '.content-slider', function(event, slick, currentSlide, nextSlide){
    blazyInit();
  });

  $(document).on("beforeChange", '.content-slider', function(event, slick, currentSlide, nextSlide){
    if ($('.content-slider video').length) {
        console.log("Pause video");
    $('.content-slider video').trigger('pause');
    }
  });

}
}

if ($('.shop-slider').length) {

    if ($('.shop-slider.slick-initialized').length) {

        $('.shop-slider').slick('refresh');

    } else {


$(".shop-slider").slick({

// normal options...
infinite: true,
lazyLoad: 'progressive',
slidesToShow: 1,
slidesToScroll: 1,
dots: false
});
    }
}

if ($('.about-slider').length) {

    if ($('.about-slider.slick-initialized').length) {

        $('.about-slider').slick('refresh');

    } else {

    $(".about-slider").slick({
        // normal options...
        infinite: true,
        lazyLoad: 'progressive',
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      dots: true,
      customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '<a>'+(i+1)+'</a>';
                },
                responsive: [
                  {
                    breakpoint: 767,
                    settings: {
                        adaptiveHeight: true
                    }
                  }
                ]

    });

}
}

if ($('.top-slider').length) {

    if ($('.top-slider.slick-initialized').length) {

        $('.top-slider').slick('refresh');

    } else {

$('.top-slider').slick({
    infinite: true,
    lazyLoad: 'progressive',
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.bottom-slider'
  });
  
}
}

if ($('.bottom-slider').length) {

    if ($('.bottom-slider.slick-initialized').length) {

        $('.bottom-slider').slick('refresh');

    } else {


  $('.bottom-slider').slick({
    infinite: true,
    lazyLoad: 'progressive',
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.top-slider'
  });

}
}


if ($('.product-slider').length) {

    if ($('.product-slider.slick-initialized').length) {
        
        $('.product-slider').slick('refresh');

    } else {    

$('.product-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    arrows: true,
    fade: false
});

    }
}

/* if ($('.product-thumbs').length) {

    console.log("Thumbs init");

$('.product-thumbs').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    asNavFor: '.product-slider',
    focusOnSelect: true
});

}

if ($('.product-slider').length && $('.product-thumbs').length) {

    console.log("Thumbs Script init");

// Remove active class from all thumbnail slides
$('.product-thumbs .slick-slide').removeClass('slick-active');

// Set active class to first thumbnail slides
$('.product-thumbs .slick-slide').eq(0).addClass('slick-active');

// On before slide change match active thumbnail to current slide
$('.product-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;
    $('.product-thumbs .slick-slide').removeClass('slick-active');
    $('.product-thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
});

}*/

if ($('.related-products').length) {

    console.log("Related Slider init");
$(".related-products").slick({

// normal options...
infinite: true,
lazyLoad: 'progressive',
slidesToShow: 3,
slidesToScroll: 3,
dots: false,
arrows: true
});
}

}

/* smooth scroll to hash */

export function hashScrollInit() {

    console.log("hashScrollInit");

if (window.location.hash) {
    window.scrollTo(0, 0);
    var hash = window.location.hash;

    if ($(hash).length) {

        console.log("hash: " + hash);

        setTimeout(() => { 
            
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - 56
                }, 900, 'swing');
                  

        }, 500);
        
    }
} else {

    window.scrollTo(0, 0);

}
}

/* team member text height */

export function teamMemberTextInit() {
    if ($('.team-member-text').length) {
        var containerHeight = $('.team-member-text').height();
        var box1Height = $('.team-member-text .team-heading').outerHeight();
        var box2Height = containerHeight - box1Height;
        $('.team-member-text .vertical-scroll').css('height', box2Height + 'px');
    }
}

/* paypal button */

export function paypalButtonsInit() {
    if ($('form[target="paypal"]:not(.view-cart-button) input[name="submit"]').length) {
        console.log( "Change PayPal button" );
        $('form[target="paypal"]:not(.view-cart-button) input[name="submit"]').attr('src','/dist/img/button-paypal-add-to-basket.svg');
    }
}

/* snipcart button */

export function snipCartInit() {
// find matching attribute and set its value
$('.option select').unbind('change').change(function(e){
    var $addButton = $(this).closest('.product-detail').find('.snipcart-add-item');
    var changedAttribute = $(this).attr('name');

    if (changedAttribute.indexOf('data-item-custom') !== -1) {
        // set custom field value
        $addButton.attr(changedAttribute + '-value', $(this).val());
    } else {
        // change attribute directly (data-item-quantity)
        $addButton.attr(changedAttribute, $(this).val());
    }
});
}

export function fluidVidsInit() {
    if ($('.fluid-video-container').length) {
        console.log("fluidVids init");
            fluidvids.init({
                selector: ['iframe', 'object'], // runs querySelectorAll()
                players: ['www.youtube.com', 'player.vimeo.com'] // players to support
              });
    }
}

/* open tab on entry */

export function getUrlParameter(sParam) {
    console.log("getUrlParameter");
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
}

export function tabsInit() {
    console.log("tabsInit");
    if ($('.foundation-tabs').length) {
var tab = getUrlParameter('tab');
if (typeof tab === "undefined") {
console.log("tab undefined");
} else {     
    console.log("tab: " + tab);  
    if (tab == 'about') {
        $('#nav-about').tab('show');
    } else if (tab == 'whatwedo') {
        $('#nav-what-we-do').tab('show');
    }  else if (tab == 'ourprojects') {
        $('#nav-our-projects').tab('show');
    } else if (tab == 'workwithus') {
        $('#nav-work-with-us').tab('show');
    }  

    }
}
}



/* search results */

export function searchInit() {
    console.log("searchInit");
$('.js-search-input').autocomplete({
    serviceUrl: '/search.json',
    appendTo: $('.js-search-wrapper'),
    triggerSelectOnValidInput: false,
    onSelect: function (suggestion) {
        window.location.href = suggestion.url
    },
    transformResult: function(response){
        return {
            suggestions: $.map(JSON.parse(response).data, function(dataItem) {
                return { value: dataItem.title, url: dataItem.url };
            })
        };
    }
});
}

/* window triggers */

$(window).bind('resize orientationChange ', function () {
    blazyInit();
    teamMemberTextInit();
    if ($('section.work-header').length) {
        mobHeaderInit('section.work-header');
    }
    if ($('#mainNav.show').length) {
        var windowHeight = window.innerHeight - 56;
        $("#mainNav").css('height', windowHeight + 'px');
    }
    if ($('#search.show').length) {
        var windowHeight = window.innerHeight - 56;
        $("#search").css('height', windowHeight + 'px');
    }
    if($('div.work-sort-menu').hasClass('hidden')) {
    } else {
        $('div.work-sort-menu').addClass('hidden');
    }
});

$(window).bind('load', function () {
    if ($('section.work-header').length) {
        mobHeaderInit('section.work-header');
    }
    /*if ($('section.programmes-header').length) {
        mobHeaderInit('section.programmes-header');
    }*/
});


/* other triggers */

$(document).on("click touch", 'header.website-header .logo a', function(event) {
    $('.modal.show').modal('hide');
    $(".website-header .menu-button").removeClass('active');
    $(".website-header .search-button").removeClass('active');
});

$(document).on("click touch", 'header.website-header .menu-button', function(event) {
    if ($("#mainNav").hasClass('show')) {
        $("#mainNav").removeClass('show');
        $("body").removeClass('modal-open');
        $(".website-header .menu-button").removeClass('active');
    } else {
        $('.modal.show').modal('hide');
        var windowHeight = window.innerHeight - 56;
        $("#mainNav").css('height', windowHeight + 'px');
        $("#mainNav").addClass('show');
        $("body").addClass('modal-open');
        $(".website-header .menu-button").addClass('active');
        $(".website-header .search-button").removeClass('active');
    }    
});

$(document).on("click touch", '#mainNav a', function(event) {
    $("#mainNav").removeClass('show');
    $("body").removeClass('modal-open');
    $(".website-header .menu-button").removeClass('active');
});

/*$(document).on('show.bs.modal','#mainNav', function (e) {
    var windowHeight = window.innerHeight - 56;
    //console.log('windowHeight = ' + windowHeight);
    $(this).css('height', windowHeight + 'px');
    $(".website-header .search-button").removeClass('active');
    $(".website-header .menu-button").addClass('active');
    $('.modal.show').modal('hide');
    var that=$(this);
    var id=that.attr('id');
    setTimeout(function(){
        $('.modal-backdrop').attr('data-id',id);
    });
});

$(document).on('hide.bs.modal','#mainNav', function (e) {
    $(".website-header .menu-button").removeClass('active');
});*/

$(document).on("click touch", 'header.website-header .search-button', function(event) {
    if ($("#search").hasClass('show')) {
        $("#search").removeClass('show');
        $("body").removeClass('modal-open');
        $(".website-header .search-button").removeClass('active');
    } else {
        $('.modal.show').modal('hide');
        var windowHeight = window.innerHeight - 56;
        $("#search").css('height', windowHeight + 'px');
        $("#search").addClass('show');
        $("body").addClass('modal-open');
        $(".website-header .search-button").addClass('active');
        $(".website-header .menu-button").removeClass('active');
    }    
});

$(document).on("click touch", '#search div.autocomplete-suggestion', function(event) {
    $("#search").removeClass('show');
    $("body").removeClass('modal-open');
    $(".website-header .search-button").removeClass('active');
});

/*$(document).on('show.bs.modal','#search', function (e) {
    var windowHeight = window.innerHeight - 56;
    //console.log('windowHeight = ' + windowHeight);
    $(this).css('height', windowHeight + 'px');
    $(".website-header .menu-button").removeClass('active');
    $(".website-header .search-button").addClass('active');
    $('.modal.show').modal('hide');
    var that=$(this);
    var id=that.attr('id');
    setTimeout(function(){
        $('.modal-backdrop').attr('data-id',id);
        setTimeout(() => { focusInput('input#headerSearchInput'); }, 500);
    });
});

$(document).on('hide.bs.modal','#search', function (e) {
    $(".website-header .search-button").removeClass('active');
});*/

$(document).on("click touch", '.programmes-entry .film-link a.play-button', function(event) {
    if ($("#film").hasClass('show')) {
        if ($('#film .oembed .fluidvids').length) {
            console.log('found vimeo');
            var vimeoCode = $('#film .oembed .fluidvids').html();
            $('#film .oembed .fluidvids').html(vimeoCode);
        }
        $("#film").removeClass('show');
        $("body").removeClass('modal-open');
    } else {
        $('.modal.show').modal('hide');
        var windowHeight = window.innerHeight;
        $("#film").css('height', windowHeight + 'px');
        $("#film").addClass('show');
        $("body").addClass('modal-open');
    }    
});

$(document).on("click touch", '.programmes-entry header.overlay-header .close-video', function(event) {
    if ($("#film").hasClass('show')) {
        if ($('#film .oembed .fluidvids').length) {
            console.log('found vimeo');
            var vimeoCode = $('#film .oembed .fluidvids').html();
            $('#film .oembed .fluidvids').html(vimeoCode);
        }
        $("#film").removeClass('show');
        $("body").removeClass('modal-open');
    } else {
        $('.modal.show').modal('hide');
        var windowHeight = window.innerHeight;
        $("#film").css('height', windowHeight + 'px');
        $("#film").addClass('show');
        $("body").addClass('modal-open');
    }    
});

/*$(document).on('show.bs.modal','#film', function (e) {
    var windowHeight = window.innerHeight;
    //console.log('windowHeight = ' + windowHeight);
    $(this).css('height', windowHeight + 'px');
    var that=$(this);
    var id=that.attr('id');
    setTimeout(function(){
        $('.modal-backdrop').attr('data-id',id);
    });
    setTimeout(function(){
        setTimeout(() => { blazyInit(); }, 500);
    });    
});*/

$(document).on('show.bs.modal','#homeShowreel', function (e) {
    /*var windowHeight = window.innerHeight;
    $(this).css('height', windowHeight + 'px');*/
    var that=$(this);
    var id=that.attr('id');
    setTimeout(function(){
        $('.modal-backdrop').attr('data-id',id);
    });
    setTimeout(function(){
        setTimeout(() => { blazyInit(); }, 500);
    });    
});

$(document).on('show.bs.modal','#papersAccessForm', function (e) {
    var windowHeight = window.innerHeight - 56;
    //console.log('windowHeight = ' + windowHeight);
    $(this).css('height', windowHeight + 'px');
    var that=$(this);
    var id=that.attr('id');
    setTimeout(function(){
        $('.modal-backdrop').attr('data-id',id);
    });
});

/* lazy load after tab change */

$(document).on("shown.bs.tab", 'a[data-toggle="pill"]', function(e) {
    blazyInit();
    slickInit();
})

/* product slider thumbnails */

$(document).on("click touch", '.product-thumbs a[data-slide]', function(e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    console.log("slideno = " + slideno);
    $('.product-slider').slick('slickGoTo', slideno);
});


/* open form 

$(document).on("click touch", '.toggle-form', function(e) {
    e.preventDefault();
    $('div.form-overlay').toggleClass('hidden');
});*/

/* papers access form */

$(document).on("submit", '#papersAccessForm form', function(ev) {

    console.log("Form submitted");
    // Prevent the form from actually submitting
    ev.preventDefault();

    // Send it to the server
    $.post({
        url: '/',
        dataType: 'json',
        data: $(this).serialize(),
        success: function(response) {
            if (response.success) {
                console.log("Success");
                $('#papersAccessForm .message').text('Thanks for your request, we will get back to you soon');
                $('#papersAccessForm .message').addClass('thanks');
            } else {
                console.log("Error");
                // response.error will be an object containing any validation errors that occurred, indexed by field name
                // e.g. response.error.fromName => ['From Name is required']
                $('#papersAccessForm .message').text('There was an error submitting your request');
                $('#papersAccessForm .message').addClass('error');
            }
        }
    });
});

/* work sort menu */

$(document).on("click touch", 'header.website-header a.work-sort-button', function(event) {
    $('div.work-sort-menu').toggleClass('hidden');
});

/* holding video play button */

$('main.holding video').on('click touch', function () {
    console.log("video clicked");
    var video = $("#holding-video").get(0);
    if (video.paused) {
        video.play();
        $("main.holding").addClass('playing');
        $("main.holding").removeClass('paused');
    } else {
        video.pause();
        $("main.holding").addClass('paused');
        $("main.holding").removeClass('playing');
   }
 });

$(document).ready(function () {
    if ($('main.holding .initial-play-button').length) {
        $("main.holding .initial-play-button img").attr("src", "/dist/img/MARK-PLAY.gif?" + Math.random());
    }
});

/* home header video */

$('section.home-header-video').on('click touch', function () {
    console.log("video clicked");
    var video = $("#header-video").get(0);
    if (video.paused) {
        video.play();
        $("section.home-header-video").addClass('playing');
        $("section.home-header-video").removeClass('paused');
    } else {
        video.pause();
        $("section.home-header-video").addClass('paused');
        $("section.home-header-video").removeClass('playing');
   }
 });

$(document).ready(function () {
    if ($('section.home-header-video .initial-play-button').length) {
        $("section.home-header-video .initial-play-button img").attr("src", "/dist/img/MARK-PLAY.gif?" + Math.random());
    }
});

/* home header banner video 

$(document).on("click touch", 'section.home-header-banner-video', function(event) {
    console.log("video clicked");
    var video = $("#header-video").get(0);
    if (video.paused) {
        video.play();
        $("section.home-header-banner-video").addClass('playing');
        $("section.home-header-banner-video").removeClass('paused');
        $(".home-page .overlay-header").addClass('show');
    } else {
        video.pause();
        $("section.home-header-banner-video").addClass('paused');
        $("section.home-header-banner-video").removeClass('playing');
        $(".home-page .overlay-header").removeClass('show');
   }
 }); */

 $(document).on("click touch", 'section.home-header-banner-video .showreel-link a', function(event) {
    console.log("video clicked");
    var video = $("#header-video").get(0);
    if (video.paused) {
        video.play();
        $("section.home-header-banner-video").addClass('playing');
        $("section.home-header-banner-video").removeClass('paused');
        $(".home-page .overlay-header").addClass('show');
    } else {
        video.pause();
        $("section.home-header-banner-video").addClass('paused');
        $("section.home-header-banner-video").removeClass('playing');
        $(".home-page .overlay-header").removeClass('show');
   }
 });

 $(document).on("click touch", '.home-page .overlay-header .close-showreel', function(event) {
    console.log("video clicked");
    var video = $("#header-video").get(0);
        video.pause();
        $("section.home-header-banner-video").addClass('paused');
        $("section.home-header-banner-video").removeClass('playing');
        $(".home-page .overlay-header").removeClass('show');   
 });

/* team read more button */

$(document).on("click touch", 'button.read-more', function(event) {
    $(this).closest('div.read-more-container').removeClass('reading-less');
    $(this).closest('div.read-more-container').addClass('reading-more');
    scrollbarInit();
});

$(document).on("click touch", 'button.read-less', function(event) {
    $(this).closest('div.read-more-container').removeClass('reading-more');
    $(this).closest('div.read-more-container').addClass('reading-less');
    scrollbarInit();
});

/* disable tab links */

/*$(document).on("click touch", 'ul.nav-pills a.nav-link', function(e) {
    console.log("tab clicked");
e.preventDefault();
e.stopPropagation();
});*/

/* modular content case study */

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};



$(document).on("click touch", '.close-full-case-study .button', function(event) {
    console.log('close full case study');
    window.scrollTo(0, 0);
    $("#sticker").css('position','relative');
    $("#sticker").removeClass('stick'); 
    $('.work-modular-content').removeClass('show-full-case-study');
});

$(window).bind('load', function () {    

    function caseStudyScroll() {

        if ($('main.work-modular-content .full-case-study-button').length) {

        if($('body').width() > 767) {
    
            //console.log('window scroll');
        var windowpos = $(window).scrollTop(); //current scroll position of the window
        var windowheight = $(window).height(); //window height
        /*console.log('windowpos = ' + windowpos);
        console.log('height = ' + s.height());
        console.log('pos = ' + pos);*/
        if ((windowpos+windowheight)>pos) {
             s.addClass('stick'); //Currently visible part of the window > greater than div offset + div height, add class
             if ($('section.related-links').isInViewport()) {
                s.css('position','absolute');
            } else {
                s.css('position','fixed');
            }
        } else {
            s.css('position','relative');
            s.removeClass('stick');        
        }
        }
    }
    }

    var s = $("#sticker");
    var pos = 0;

    $(document).on("click touch", '.full-case-study-button .button', function(event) {
        console.log('show full case study');
        //window.scrollTo('#casestudy');
        $('html, body').animate({
            scrollTop: $('#casestudy').offset().top - 56
        }, 0, 'linear');
        $('.work-modular-content').addClass('show-full-case-study');
        pos = s.offset().top+s.height(); //the div's top offset + it's height
        /*console.log('offset = ' + s.offset().top);
        console.log('height = ' + s.height());
        console.log('pos = ' + pos);*/
    });

    $(window).on('resize', function() {
        //pos = s.offset().top+s.height(); 

        if($('body').width() < 768) {
            $("#sticker").css('position','relative');
    /*$("#sticker").removeClass('stick'); 
    $('.work-modular-content').removeClass('show-full-case-study');*/
        } else {
            // do nothing
        }

        caseStudyScroll();
    });


$(window).scroll(function() {
    if ($('.show-full-case-study').length) {

        caseStudyScroll();
        
} else {
    $("#sticker").css('position','relative');
    $("#sticker").removeClass('stick');     
}
});
});